<div class="container-fluid login-container login-bg">
  <img src="/assets/images/polygon_crop.png" class="img-fluid">
  <div class="row align-items-center login-container-row">
    <div class="col-md-6 title-block">
      One Stop Service for
      <div class="e-tax-title mt-2">SMART AR</div>
      <div class="e-tax-subtitle">Invoice & Receipt</div>
    </div>
    <div class="col-md-6">
      <div class="login-form">
        <div *ngIf="uiStatus == 'login';">
          <div class="welcome-text mt-sm-4">Welcome Back</div>
          <p>Please login using your email account.</p>
          <div class="form-group mt-4 mb-sm-2">
            <div class="form-label-group">
              <input type="text" class="form-control form-control-lg" placeholder="Email" name="email" [(ngModel)]="email"
                (keyup.enter)="login()">
              <label>Email</label>
            </div>
          </div>
          <div class="text-red text-center my-1 d-block">
            {{ errorMessage ? errorMessage : '&nbsp;' }}
          </div>

          <div class="form-group">
            <button class="btn btn-dv btn-block" (click)="login()">Login</button>
          </div>
        </div>
        <div *ngIf="uiStatus == 'loading'">
          <div class="welcome-text mt-sm-4">Requesting OTP <i class="fas fa-spinner fa-spin"></i></div>
        </div>
        <div *ngIf="uiStatus == 'succeed'">
          <div class="welcome-text mt-sm-4">OTP email has been sent to</div>
          <p>{{ email }}</p>
        </div>
        <div *ngIf="uiStatus == 'failed'">
          <div class="welcome-text mt-sm-4">Failed to request OTP</div>
          <p>{{ errorMessage }}</p>
          <div class="form-group">
            <button class="btn btn-dv btn-block" (click)="tryAgain()">Retry</button>
          </div>
        </div>
        <div class="float-right">
          <div class="footer-text">Powered by CODIUM</div>
        </div>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /opt/app/src/app/login/login.component.html